import React, { useMemo } from 'react';

import isEmpty from 'utils/is-empty';

import CpeConfiguration from './components/CpeConfiguration';
import Tabs from './components/Tabs';
import useStyles from './styles';
import { CpeConfiguration as CpeConfigurationInterface } from './types';

interface Props {
    cpeConfigurations:
        | {
              nvdCpeConfiguration?: [CpeConfigurationInterface];
              vulnersCpeConfiguration?: [CpeConfigurationInterface];
          }
        | undefined;
    className?: string;
}

const CpeConfigurations: React.FC<Props> = ({ cpeConfigurations, className }) => {
    const { classes, cx } = useStyles();

    const data = useMemo(() => {
        if (!cpeConfigurations || isEmpty(cpeConfigurations)) {
            return [];
        }

        const { vulnersCpeConfiguration, nvdCpeConfiguration } = cpeConfigurations;

        const output: { title: string; content: React.ReactNode }[] = [];

        if (Array.isArray(vulnersCpeConfiguration) && !isEmpty(vulnersCpeConfiguration)) {
            output.push({
                title: 'Vulners',
                content: (
                    <div>
                        {vulnersCpeConfiguration.map(({ operator, nodes }, index) => (
                            <CpeConfiguration key={index} operator={operator} data={nodes} />
                        ))}
                    </div>
                )
            });
        }

        if (Array.isArray(nvdCpeConfiguration) && !isEmpty(nvdCpeConfiguration)) {
            output.push({
                title: 'NVD',
                content: (
                    <div>
                        {nvdCpeConfiguration.map(({ operator, nodes }, index) => (
                            <CpeConfiguration key={index} operator={operator} data={nodes} />
                        ))}
                    </div>
                )
            });
        }

        return output;
    }, [cpeConfigurations]);

    if (isEmpty(data)) {
        return null;
    }

    return (
        <div className={cx(classes.root, className)}>
            <h2 className={classes.title}>{'Affected configurations'}</h2>
            <Tabs data={data} />
        </div>
    );
};

export default CpeConfigurations;
